module.exports = {
      id: "living_area-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#living_area-usage",
      toString: function () {
        return this.url;
      }
    }